import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function searchSeoTexts({ filters }, language, timeZone, cancelToken) {
    // Clean up empty or undefined filter values
    const cleanFilters = filters ? Object.keys(filters).reduce((acc, key) => {
        const value = filters[key];
        if (key && value !== undefined && value !== 'undefined' && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {}) : {};

    return await wsRequestGet('/admin/seoextradata', language, timeZone, Object.keys(cleanFilters).length > 0 ? cleanFilters : null, cancelToken);
}

export async function getSeoText(id, language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/seoextradata/get-by-id', language, timeZone, { id }, cancelToken);
}

export async function createSeoText(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/seoextradata/create', language, timeZone, data, null, cancelToken);
}

export async function updateSeoText(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/seoextradata/update', language, timeZone, data, null, cancelToken);
}

export async function deleteSeoText(id, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/seoextradata/delete', language, timeZone, null, { id }, cancelToken);
}
